import {
    useMemo, useCallback,
} from 'react'
import noop from 'lodash/noop'
import throttle from 'lodash/throttle'

import useSkyDataGridLocalStorage from 'app/PoC/DataGridDemoPages/components/hooks/useSkyDataGridLocalStorage'
import {
    SkyDataGridLocalStorage,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'
import {
    DEFAULT_MAIN_TABLE_IN_DETAILS_VIEW_WIDTH_PERCENT,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/constants'

const tableWidthPercentInitState: SkyDataGridLocalStorage = {
    tableWidthPercent: DEFAULT_MAIN_TABLE_IN_DETAILS_VIEW_WIDTH_PERCENT,
}

const THROTTLE_WAIT_MS = 300

const usePersistedTableWidthPercent = ({
    persistentKey,
    onChange = noop,
}:{
    persistentKey: string,
    onChange?: (tableWithPercent: number) => void,
}): [number, (model: number) => void] => {
    const {
        dataGridState,
        setDataGridState,
    } = useSkyDataGridLocalStorage<SkyDataGridLocalStorage>(persistentKey,
        tableWidthPercentInitState)

    const throttledSetDataGridState = useMemo(() => {
        return throttle((newState: SkyDataGridLocalStorage) => {
            setDataGridState(newState)
            onChange(newState.tableWidthPercent)
        }, THROTTLE_WAIT_MS)
    }, [
        setDataGridState,
        onChange,
    ])

    const setTableWidthPercent = useCallback((newTableWidthPercent: number) => {
        const newState = {
            tableWidthPercent: newTableWidthPercent,
        }

        throttledSetDataGridState(newState)
    }, [throttledSetDataGridState])

    const tableWidthPercent = useMemo(() => {
        return dataGridState?.tableWidthPercent || DEFAULT_MAIN_TABLE_IN_DETAILS_VIEW_WIDTH_PERCENT
    }, [dataGridState])

    return [
        tableWidthPercent,
        setTableWidthPercent,
    ]
}

export default usePersistedTableWidthPercent
